import { render, staticRenderFns } from "./DailyFeaturedTheme.vue?vue&type=template&id=58404e07"
import script from "./DailyFeaturedTheme.vue?vue&type=script&lang=js"
export * from "./DailyFeaturedTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports